import { PdfSource } from '../types'
/**
 * Converts various PDF source types to a format PDF.js can use
 */
export const getDocumentSource = async (
  source: PdfSource
): Promise<string | ArrayBuffer | Uint8Array> => {
  switch (source.type) {
    case 'url':
      return source.url
    case 'base64':
      // Convert base64 to Uint8Array
      const binaryString = atob(source.data)
      const bytes = new Uint8Array(binaryString.length)
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes
    case 'arrayBuffer':
      return source.data
    case 'file':
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as ArrayBuffer)
        reader.onerror = reject
        reader.readAsArrayBuffer(source.file)
      })
    default:
      throw new Error('Invalid PDF source type')
  }
}

/**
 * Creates PDF.js document options from the source
 */
export const createDocumentOptions = async (source: PdfSource) => {
  const data = await getDocumentSource(source)

  if (source.type === 'url') {
    return {
      url: data as string,
      httpHeaders: source.httpHeaders,
    }
  }

  return { data }
}
